module.exports = __webpack_public_path__ + "app/img/turtle2_protection2.318981a3.jpg";